export * from './IconQuote';
